/**
 * Converts alerts from the API to UI badges.
 * Can
 * @param alert
 * @returns {{level: string, message: string}}
 */

export const badgeClasses = {
  danger: 'badge badge-danger',
  warning: 'badge badge-warning',
  info: 'badge badge-info',
  unknown: 'badge badge-secondary',
};

const AlertToUIBadge = (alert) => {
  let badge = {
    level: 'unknown',
    message: 'none',
  };

  switch (alert.type) {
    case 'visit':
      if (alert.subtype === 'visit_soon') badge.message = 'Visit Soon';
      if (alert.subtype === 'require_visit') badge.message = 'Visit Now';
      break;

    case 'respiration':
      if (alert.subtype === 'high_urgent') {
        badge.level = 'badge-danger';
        badge.message = 'High RR';
      }

      if (alert.subtype === 'high_warning') {
        badge.level = 'warning';
        badge.message = 'High RR';
      }

      if (alert.subtype === 'low_urgent') {
        badge.level = 'badge-danger';
        badge.message = 'Low RR';
      }

      if (alert.subtype === 'low_warning') {
        badge.level = 'warning';
        badge.message = 'Low RR';
      }
      break;

    case 'bedexit':
      badge.level = 'badge-danger';
      badge.message = 'Bed Exit';
      break;

    default:
      return badge;
  }

  return badge;
};

export default AlertToUIBadge;
